export default "/kiban/_next/static/images/recognizeMark-8d7bf2f15762871a67324a30f537508f.png";